// Module
var code = "<style>:host{width:120px;display:block;--accent-color:blue;--background-color:white}input[type=range]{width:100%;accent-color:var(--accent-color);background:var(--background-color);outline:0}</style> <input id=\"slider\" type=\"range\">";
// Exports
export default code;